export default {
  title: 'Vous semblez hors ligne',
  description:
    "Veuillez cliquer sur « Recharger la page » et/ou vérifier votre connexion Internet pour vous assurer d'être en ligne 😊",
  custom_button: {
    reload: 'Recharger la page',
  },
};
